/** The colour of the amount of a movement, by its type: the list and the summary of the movements show it the same. */
export default function getCurrencyColor(type?: string) {
  switch (type) {
    case 'DEBIT':
      return 'error';
    case 'CREDIT':
      return 'success';
    case 'TRANSFER':
      return 'info';
    default:
      return 'inherit';
  }
}
